import React, { useContext, useEffect, useRef, useState } from "react";
import CustomIconButton from "../../components/CustomIconButton";
import {
  Avatar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
  Tooltip,
  IconButton,
  Popover,
  CircularProgress,
} from "@mui/material";
import { alpha } from "@mui/system";
import dayjs from "dayjs";
import { ReactComponent as ExportIcon } from "../../assets/images/ralvie/export-icon.svg";
import { ReactComponent as CloseIcon } from "../../assets/images/ralvie/CloseReport.svg";
import { ReactComponent as CloseIconDark } from "../../assets/images/ralvie/CloseReportDark.svg";
import CustomButton from "../../components/CustomButton";
import { css } from "@emotion/css";
import CustomCheckBox from "../../components/CustomCheckBox";
import { ReactComponent as ProjectIcon } from "../../assets/images/ralvie/Project.svg";
import { exportProjectReport, exportTaskReport } from "../../services/ReportService";
import { useTranslation } from "react-i18next";
import "./ExportProjectReport.scss";
import TimesheetWeekPicker from "../dashboard/TimesheetWeekPicker";
import AppContext from "../../config/AppContext";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
import TimesheetDatePickerWB from "../timesheet/TimesheetDatePickerWB";
import { toast } from "sonner";
import CommonUtil from "../../util/CommonUtils";
import CancelDialog from "../project/CancelDialog";
import CustomizedDatePickerReport from "../../components/CustomizedDatePickerReport";
import { sidebarContext } from "../../util/context";
import UpgradePopup from "../../components/subscription-component/UpgradePopup";
import { useNavigate } from "react-router-dom";
import RestrictPermissionPopup from "../../components/subscription-component/RestrictPermissionPopup";
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from "material-ui-popup-state/hooks";

export default function ExportProjectReport(props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState(undefined);
  const [isIncludeMemberContribution, setIsIncludeMemberContribution] =
    useState(false);
  const timeRef = useRef();
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const isStartDateValid =
    startDate.isBefore(endDate,"day") || startDate.isSame(endDate,"day");
  const [projects, setProjects] = React.useState([]);
  const [selectedProjects, setSelcetdProjects] = React.useState([]);
  const projectsRef = useRef(selectedProjects);
  const theme = useTheme();
  const isXlScreen = useMediaQuery(theme.breakpoints.up("xl"));
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { mode } = useContext(AppContext);
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const { subscriptionDetails } = useContext(sidebarContext);
  const [upgradePopupOpen, setUpgradePopupOpen] = useState(false);
  const [restrictPopupOpen, setRestrictPopupOpen] = useState(false);
  const [initialStartDate, setInitialStartDate] = useState(dayjs());
  const [initialEndDate, setInitialEndDate] = useState(dayjs());
  const [initialSelectedProjects, setInitialSelectedProjects] = useState([]);
  const [initialIncludeMemberContribution, setInitialIncludeMemberContribution] = useState(false);
  const [exportType, setExportType] = useState("project");
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();

  const popupExport = usePopupState({
  variant: "popover",
  popupId: "export-popup",
});

  useEffect(() => {
    if (props?.reports) {
      let projects = [];
      props?.reports?.forEach((r) => {
        projects.push(r?.project);
      });
      setProjects(projects);
      // handleSelecetAll(true);
    }
  }, [props.reports]);

  const handleClose = () => {
    setError(undefined);
    setOpen(false);
    handleSelecetAll(false);
    setStartDate(dayjs());
    setEndDate(dayjs());
    setIsIncludeMemberContribution(false);
  };

  // const handleSubmit = () => {
  //   exportProjectReport(selectedProjects).then((res) => {
  //     setSelcetdProjects([]);
  //     setOpen(false);
  //   });
  // };
  const handleSubmit = () => {
  if (exportType === "project" && selectedProjects?.length < 1) {
    setError(t("RAL0718"));
    return;
  }

  if (exportType === "task" && selectedProjects?.length < 1) {
    setError(t("RAL0718"));
    return;
  }

  setLoading(true);

  var utc = require("dayjs/plugin/utc");
  var timezone = require("dayjs/plugin/timezone");
  dayjs.extend(utc);
  dayjs.extend(timezone);
  let dateTz = dayjs.tz(startDate, CommonUtil.getTimeZoneId());
  let startTime = dateTz.startOf("day");
  dateTz = dayjs.tz(endDate, CommonUtil.getTimeZoneId());
  let endTime = dateTz.endOf("day");
  let start = startTime.isUTC()
    ? startTime.format()
    : startTime.utc().format();
  let end = endTime.isUTC() ? endTime.format() : endTime.utc().format();

  const exportPromise = exportType === "project" 
    ? exportProjectReport(
        selectedProjects,
        props.clientId,
        props.member,
        start,
        end,
        props.tags,
        isIncludeMemberContribution
      )
    : exportTaskReport(
        selectedProjects,
        props.member,
        start,
        end
      );

  exportPromise
    .then(() => {
      handleClose();
    })
    .catch((error) => {
      toast.error(t("RAL1192"));
    })
    .finally(() => {
      setLoading(false);
    });
};

  const handleSelecetAll = (value) => {
    if (value) {
      setError(undefined);
      let projectIds = [];
      props?.reports?.forEach((r) => {
        projectIds.push(r?.project?.id);
      });
      setSelcetdProjects(projectIds);
    } else {
      setSelcetdProjects([]);
    }
  };

  const handleSelection = (id) => {
    setError(undefined);
    let projectIds = [...selectedProjects]; // Make a copy of the array
    if (projectIds.length > 0 && projectIds.find((pid) => pid === id)) {
      // Use a callback function in .find()
      let updatedList = projectIds.filter((pid) => pid !== id); // Filter out the selected id
      setSelcetdProjects(updatedList); // Make sure to update state correctly
      projectsRef.current = updatedList;
    } else {
      projectIds.push(id); // Add the new id
      setSelcetdProjects(projectIds); // Update state
      projectsRef.current = projectIds;
    }
  };

  const checkProjectSelection = (id) => {
    if (id !== undefined && selectedProjects && selectedProjects.length > 0) {
      // Use a callback function in .find() to check if the id exists in the array
      let pid = selectedProjects.find((pid) => pid === id);
      return !!pid; // Return true if pid is found, otherwise return false
    }
    return false;
  };

  const isActive = ["live", "non_renewing"].includes(subscriptionDetails?.status);
  const reportFeature = subscriptionDetails?.features?.find(
    (feature) => feature?.feature?.code === "REPORT"
  );
  const reportValue = reportFeature?.value;

  const handleClickOpen = () => {
    if (!isActive || (reportValue !== "All" && reportValue !== "Export")) {
      if (!["OWNER", "MANAGER"].includes(CommonUtil.getRoleCode())) {
        setRestrictPopupOpen(true);
      } else {
        setUpgradePopupOpen(true);
      }
    } else {
      setOpen(true);
    }
  };

  const projectCard = (project) => {
    return (
      <Box
        className="projectCardOuter"
        sx={{
          border: `1px solid ${
            mode === "light" ? "#eaebef !important" : "#313131 !important"
          }`,
        }}
      >
        <CustomCheckBox
          id="projectreport-select-checkbox"
          onChange={() => handleSelection(project?.id)}
          checked={checkProjectSelection(project?.id)}
        />
        <Avatar
          id="projectreport-project-avatar"
          className="projectAvatar"
          sx={{
            width: "46px",
            height: "46px",
            backgroundColor: (theme) => alpha(project?.color, 0.15),
            ...(project?.color?.startsWith("#f") && {
              border: "1px solid #E0E0E0",
            }),
            ...(project?.color?.startsWith("#1") && {
              border: "1px solid #000000",  
            
            }),
            marginLeft:1,
          }}
        >
          <ProjectIcon id="projectreport-project-icon" fill={project?.color}                              
            style={{
                  ...(project?.color?.startsWith("#f") && {
                      fill: "#E0E0E0",
                                }),
                                ...(project?.color?.startsWith("#1") && {
                                  fill: "#000000",  
                                }),
                              }} opacity={0.5} />
        </Avatar>
        <Box display="flex" flexDirection={"column"}>
        <Tooltip title={project?.name}>
          <Typography
            id="projectreport-project-name"
            className="projectName"
           sx={{
             color: mode === "light" ? "#242424 !important" : "#F8F8F8 !important",
             whiteSpace: "nowrap",       
             overflow: "hidden",        
             textOverflow: "ellipsis",
             maxWidth: "400px", 
             marginTop: !project?.clientName &&  CommonUtil.getOS() === "MacOS" ? '6.5px' : ''       
           }}
          >
            {project?.name}
           </Typography>
          </Tooltip>
          {project?.clientName && (<Tooltip title={project?.clientName || ''} >
            <Typography
             id="projectreport-client-name"
             className="projectClientName"
                sx={{
                color: mode === "light" ? "#242424cc !important" : "#f8f8f8cc !important",
                whiteSpace: "nowrap",        
                overflow: "hidden",        
                textOverflow: "ellipsis",   
                maxWidth: "400px",       
                }}
            >
               {project?.clientName}
             </Typography>
          </Tooltip>)}
        </Box>
      </Box>
    );
  };

  const handleCancelButton = () => {
    const isDateRangeModified =
      !dayjs(startDate).isSame(dayjs(initialStartDate), "day") ||
      !dayjs(endDate).isSame(dayjs(initialEndDate), "day");
    const isCheckboxModified =
      JSON.stringify(selectedProjects) !==
        JSON.stringify(initialSelectedProjects) ||
      isIncludeMemberContribution !== initialIncludeMemberContribution;
    if (isDateRangeModified || isCheckboxModified) {
      setIsCancelDialogOpen(true);
    } else {
      handleClose();
    }
  };

  const handleCloseCancelDialog = () => {
    setIsCancelDialogOpen(false);
  };

  const handleConfirmCancel = () => {
    setError(undefined);
    setOpen(false);
    setIsCancelDialogOpen(false);
    handleSelecetAll(false);
    setStartDate(dayjs());
    setEndDate(dayjs());
    setIsIncludeMemberContribution(false);
  };

  
  const getPopupTitle = (subscriptionDetails, t, isRestrictPopup = false) => {
    if (CommonUtil.getStatusCondition(subscriptionDetails)) {
      return isRestrictPopup ? t("RAL0902") : t("RAL0859");
    } else if (CommonUtil.isPlanCodeDefault(subscriptionDetails)) {
      return t("RAL0850");
    } else {
      return t("RAL0852");
    }
  };
  
  const getPopupContent = (subscriptionDetails, t, isRestrictPopup = false) => {
    if (CommonUtil.getStatusCondition(subscriptionDetails)) {
      return isRestrictPopup ? t("RAL0903") : t("RAL0860");
    } else if (CommonUtil.isPlanCodeDefault(subscriptionDetails)) {
      return t("RAL0849");
    } else {
      return t("RAL0851");
    }
  };

  return (
    <div>
    <Box>
      <CustomIconButton
        id="btn-custom-export-project"
        name="btn-custom-export-project"
        title={t("RAL0973")}
        size={isXlScreen ? "large" : "md"}
        variant="square"
        type="contained"
        border={"none"}
        lightMode={<ExportIcon height={isXlScreen ? "18px" : "14px"} />}
        darkMode={<ExportIcon height={isXlScreen ? "18px" : "14px"} />}
        onClick={popupExport.open}
        {...bindTrigger(popupExport)}
      />

      <Popover
        {...bindPopover(popupExport)}
         anchorOrigin={{
         vertical: "bottom",
         horizontal: "right",
        }}
       transformOrigin={{
        vertical: "top",
        horizontal: "right",
       }}
       PaperProps={{
        sx: {
          boxShadow: "0px 3px 6px rgba(0,0,0,0.12)",
          minWidth: "160px",
        },
      }}
    >
    <Box
      py={1}
      px={0}
      className={css`
        background: ${mode == "dark" ? "#101010" : "#ffffff"} 0% 0%
          no-repeat padding-box;
        color: ${mode == "dark" ? "#f8f8f8cc" : "#242424"};
        opacity: 1;
      `}
    >
      <Box
        onClick={() => {
          setExportType("project");
          popupExport.close();
          handleClickOpen();
        }}
        py={1}
        px={2}
        className={css`
          cursor: pointer;
          &:hover {
            background: ${mode == "dark" ? "#1e1e1e" : "#f5f5f5"};
          }
        `}
        id="btn-report-project-export"
      >
        {t("RAL1188")}
      </Box>
      <Box
        onClick={() => {
          setExportType("task");
          popupExport.close();
          handleClickOpen();
        }}
        py={1}
        px={2}
        className={css`
          cursor: pointer;
          &:hover {
            background: ${mode == "dark" ? "#1e1e1e" : "#f5f5f5"};
          }
        `}
        id="btn-report-task-export"
      >
        {t("RAL1189")}
      </Box>
    </Box>
  </Popover>
</Box>
      <Dialog
        className="ExportProjectReport"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen={fullScreen}
        fullWidth={true}
      >
        <Box sx={{ backgroundColor: mode === "light" ? "#ffffff" : "#101010" }}>
          <Box
            sx={{
              position: "sticky",
              top: 8, 
              backgroundColor: mode === "light" ? "#ffffff" : "#101010",
              zIndex: 2,
            }}
          >
         <DialogTitle className="ExportTitle" sx={{ color: mode === "light" ? "#242424" : "#f8f8f8" }} id="alert-dialog-title">
  {t("RAL0478")}
  <IconButton
    edge="end"
    color="inherit"
    onClick={handleClose}
    sx={{ position: 'absolute', right: 36, top: 8,   '&:hover': {
      backgroundColor: mode === 'dark' 
      ? 'rgba(255, 255, 255, 0.2)'
      : 'rgba(0, 0, 0, 0.1)',
      borderRadius: '4px',
    }, }}
  >
     {mode === "light" ? <CloseIcon  /> : <CloseIconDark />}
  </IconButton>
</DialogTitle>
          <DialogContent className="exportDialogContent" width={"100%"}>
            <Box py={2}>
              <Typography
                sx={{ color: mode === "light" ? "#242424cc" : "#f8f8f8cc" }}
                className="ExportDesc"
                id="alert-dialog-title-info"
              >
                {exportType === "project" ? t("RAL0479") : t("RAL1190")}
              </Typography>
            </Box>
            <Box display="flex">
              <Box>
                <Typography
                  sx={{
                    color:
                      mode === "light"
                        ? "#242424 !important"
                        : "#F8F8F8 !important",
                        whiteSpace: 'nowrap', 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis',
                        marginTop:1.5
                  }}
                  className={css`
                    font: normal normal normal 16px/19px Gotham;
                    letter-spacing: 0px;
                    font-weight: 600;
                  `}
                >
                  <span
                    className={css`
                       font:normal normal normal 16px / 20px Gothambold !important;
                      letter-spacing: 0px;
                      margin-right: 1.6rem;
                      opacity: 0.8;
                    `}
                    id="alert-dialog-daterange"
                  >
                    {t("RAL0480")}
                  </span>
                </Typography>
              </Box>
              <Box display={"flex"} flexDirection={"column"}>
                <Box display={"flex"} alignItems={"center"}>
                  <Box 
                  // className={`${mode === 'dark' ? "customDatePickerInputBoxBackGround" : ""}`}
                  >
                    <CustomizedDatePickerReport
                      id="btn-start-clndr"
                      onChange={(date) => {
                        setStartDate(date);
                      }}
                      value={startDate}
                      maxDate={dayjs().utc().format()}
                    />
                  </Box>
                  <Box mx={1}> - </Box> {/* Added mx for spacing */}
                  <Box 
                  // className={`${mode === 'dark' ? "customDatePickerInputBoxBackGround" : ""}`}
                  >
                    <CustomizedDatePickerReport
                      id="btn-end-clndr"
                      onChange={(date) => {
                        setEndDate(date);
                      }}
                      value={endDate}
                      maxDate={dayjs().utc().format()}
                    />
                  </Box>
                </Box>
                {!isStartDateValid && (
                  <Box display={"flex"} alignItems={"center"} pt={1} pl={2}>
                    <Box pr={1} display="flex" alignItems="center">
                      <ErrorIcon />
                   </Box>
                    <Box display="flex" alignItems="center">
                      <Typography id="alert-dialog-date-message" className="helper-text">
                        {t("RAL0483")}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>

            <Box
              py={1}
              className={css`
                border-radius: 5px;
                opacity: 1;
                display: flex;
                align-items: center;
                margin-bottom: 1px;
              `}
            >
                 <CustomCheckBox
                id="projectreport-select-checkbox"
                onChange={() =>
                  handleSelecetAll(
                    selectedProjects?.length === props?.reports?.length
                      ? false
                      : true
                  )
                }
                checked={
                  (props?.reports?.length !=0 && selectedProjects?.length === props?.reports?.length)
                    ? true
                    : false
                }
              />

              <Box display="flex" flexDirection={"column"} rowGap={0.5}>
                <Typography
                  sx={{
                    color:
                      mode === "light"
                        ? "#242424 !important"
                        : "#F8F8F8 !important",
                  }}
                  className={css`
                    font: normal normal normal 16px/19px GothamMedium;
                    letter-spacing: 0px;
                  `}
                >
                  <span
                    className={css`
                      font: normal normal 16px/19px Gotham;
                      letter-spacing: 0px;
                      margin-right: 11.3rem;
                    `}
                    id="projectreport-selectall-text"
                  >
                    {t("RAL0482")}
                  </span>
                </Typography>
              </Box>
              
              {exportType === "project" && (
              <CustomCheckBox
                id="projectreport-select-checkbox"
                onChange={() =>
                  setIsIncludeMemberContribution(!isIncludeMemberContribution)
                }
                checked={isIncludeMemberContribution}
              />
              )}

            {exportType === "project" && (
              <Box
                display="flex"
                flexDirection={"column"}
                rowGap={0.5}
                flexGrow={1}
              >
                <Typography
                  sx={{
                    color:
                      mode === "light"
                        ? "#242424 !important"
                        : "#F8F8F8 !important",
                  }}
                  className={css`
                    font: normal normal normal 16px/19px GothamMedium;
                    letter-spacing: 0px;
                  `}
                >
                  <span
                    className={css`
                      font: normal normal 16px/19px Gotham;
                      letter-spacing: 0px;
                    `}
                    id="projectreport-member-text"
                  >
                    {t("RAL0481")}
                  </span>
                </Typography>
              </Box>
            )}

            </Box>
            {error && (
              <Box display={"flex"} alignItems={"center"}>
                <Box item pr={0.5} mt={0.5}>
                  {<ErrorIcon id="projectreport-error-icon"/>}
                </Box>
                <Box item>
                  <Typography id="projectreport-error-message" className="helper-text">{error}</Typography>
                </Box>
              </Box>
            )}
          </DialogContent>
          </Box>

          <DialogContent className="exportDialogContent" width={"100%"}>
            <Box
              className="projectCardDiv"
              display={"flex"}
              flexDirection={"column"}
              rowGap={1}
            >
              {projects?.map((r) => {
                return projectCard(r);
              })}
            </Box>
          </DialogContent>
          <DialogActions className="DialogActionsDiv"
            sx={{
              backgroundColor:
                mode === "light" ? "#FFFFFF !important" : "#121212 !important",
            }}>
            <Box className="DialogActionsBtns">
              <CustomButton
                place="sp-cancel"
                id="btn-cancel-project-report"
                name="btn-cancel-member"
                variant="outlined"
                size="large"
                fullWidth="fullWidth"
                height="50px"
                minWidth="150px"
                onClick={handleCancelButton}
              >
                <span id="btn-cancel-member">{t("RAL0177")}</span>
              </CustomButton>
              <CustomButton
                id="btn-add-project-report"
                name="btn-add-project-report"
                variant="contained"
                size="large"
                fullWidth="fullWidth"
                height="50px"
                minWidth="150px"
                disabled={!isStartDateValid || loading}
                onClick={() => {
                  handleSubmit();
                }}
              >
                 {loading ? (
                  <CircularProgress size={24} color="inherit" />
                  ) : (
                 <span id="btn-add-member">{t("RAL0047")}</span>
                )}
              </CustomButton>
            </Box>
            <CancelDialog
              open={isCancelDialogOpen}
              onClose={handleCloseCancelDialog}
              onConfirm={handleConfirmCancel}
              header={t("RAL0742")}
              message={t("RAL0743")}
            />
          </DialogActions>
        </Box>
      </Dialog>

    {["OWNER", "MANAGER"].includes(CommonUtil.getRoleCode()) && (
      <UpgradePopup
        open={upgradePopupOpen}
        onClose={() => setUpgradePopupOpen(false)}
        onConfirm={() => {
          if (CommonUtil.getRoleCode() === "OWNER" || CommonUtil.getRoleCode() === "MANAGER") {
            navigate("/subscription-manage");
          } else {
            navigate("/page-not-found");
          }
        }}
        title={getPopupTitle(subscriptionDetails, t)}
        content={getPopupContent(subscriptionDetails, t)}
        cancelText={t("RAL0177")}
        confirmText={t("RAL0848")}
      />
    )} 


     {!["OWNER"].includes(CommonUtil.getRoleCode()) && ( 
          <RestrictPermissionPopup
            open={restrictPopupOpen}
            onClose={() => setRestrictPopupOpen(false)}
            title={getPopupTitle(subscriptionDetails, t, true)}
            content={getPopupContent(subscriptionDetails, t, true)}
            cancelText={t("RAL0177")}
          />
        )}

    </div>
  );
}
